import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from '../../../helpers/Button';
import Logo from '../../../images/pm_logo.png';
import SideNav from './SideNav';

import ProfileBar from './ProfileBar';
import NotificationBar from './NotificationBar';


const Header = () => {
    const [visible, setVisible] = useState(false)
    const location = useLocation()

    useEffect(()=>{
        if(location.pathname === "/"){
            setVisible(true)
        } 
    }, [])

    return (
        <div className="layout-topbar">
            <div className="flex">
                <SideNav visible={visible} setVisible={setVisible} />
                <Button icon="pi pi-bars" className="topbar-menu-btn" onClick={() => setVisible(true)} />
                <div className="logo me-lg-5 me-3">
                    <img src={Logo} alt="" style={{ height: '21px', marginTop: '10px' }} />
                </div>
            </div>
            <div className="flex justify-content-end">
                <NotificationBar />
                <ProfileBar />
            </div>
        </div>
    )
}

export default Header;
